module.exports = __webpack_public_path__ + "img/eccang.9b51e63d.png";